import store from './store';
import { Route } from 'vue-router';

export function routeEnterHelper(
    condition: boolean,
    from: Route,
    next: ((to?: false | string | void | any ) => void),
): void {
    if (condition) {
        store.dispatch('activatePage', { n: 0}).then(() => {
            next();
        });
    } else {
        next(from.name ? false : { name: 'page', params: { n: 1} });
    }
}
